import React, {Component, PropTypes} from 'react'
import DynamicImageComponent from './dynamicImageComponent'

export default class DynamicImageListComponent extends Component {
    static propTypes = {
        documentId: PropTypes.string,
        maxPageNumber: PropTypes.number,
        pageDistances: PropTypes.number
    }

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const {documentId, maxPageNumber, pageDistances} = this.props

        const rows = [];
        for (let pageNumber = 1; pageNumber <= maxPageNumber; pageNumber++) {
            rows.push(<DynamicImageComponent
                key={"documentImages_"+documentId+"_"+pageNumber}
                documentId={documentId}
                pageNumber={pageNumber}
                marginBottom={pageDistances}
            />);
        }

        return (
            <div>
                {rows}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/handleSignaturePlaceholders/dynamicImageListComponent.jsx